import React from 'react';

import Schedule from '../../snippets/Schedule';
import MovieDetails from './impl/MovieDetails/MovieDetails';
import MoviePageSchedule from './impl/MoviePageSchedule/MoviePageSchedule';
import MovieSlider from './impl/MoviePageSlider';

class MoviePage extends React.Component {
  componentDidMount() {
    if (this.props.wsid) {
      let session = this.props.film.Sessions.filter(session => session.Id === this.props.wsid)[0];
      this.props.handleSessionClick(session);
    }
  }

  render() {
    if (typeof this.props.film === typeof undefined) {
      return null;
    }
    return (
      <div className="mvi">
        <MovieSlider
          film={this.props.film}
          openTrailer={this.props.openTrailer} />
        <MoviePageSchedule
          film={this.props.film}
          handleSessionClick={this.props.handleSessionClick}
          cssDesktopClassForPage='movie-page'
          cssMobileClassForPage='schedule__filters'
        />
        <MovieDetails
          film={this.props.film}
        />
        <Schedule
          heading="Дивіться також"
          films={this.props.films}
          dates={this.props.dates}
          showHallFilter={false}
          showFormatFilter={false}
          limit={6}
          handleSessionClick={this.props.handleSessionClick}
          cssDesktopClassForPage='movie-page'
        />
      </div>
    );
  }
}

export default MoviePage


// WEBPACK FOOTER //
// ./src/components/pages/MoviePage/MoviePageWrapper.jsx